export const VossProductGroupTagType = {
    Migration: 0,
    Exclusive: 1
}